const Subscribing = () => {
    return (
        <svg
            width={18}
            height={18}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity=".4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.906 1A1 1 0 0 1 4.9 0h8.01a1 1 0 0 1 0 2H4.9a.995.995 0 0 1-.995-1ZM.01 8.095l.801 8.01A2.123 2.123 0 0 0 2.901 18H14.91A2.129 2.129 0 0 0 17 16.104l.801-8.01A1.885 1.885 0 0 0 15.905 6H1.906C.76 6-.104 6.956.01 8.095Zm2.001-.09 13.789.003L14.906 16h-12L2.01 8.004ZM2.901 3a1 1 0 0 0 0 2H14.91a1 1 0 0 0 0-2H2.901Z"
                fill="#fff"
            />
        </svg>
    );
};

export default Subscribing;
